import { RoomQuestion } from "@/core/api/room.question.api";

export default {
  registerQuestion: async ({dispatch, commit, getters, rootGetters}, content) => {
    await RoomQuestion.registerQuestion(content)
  },

  deleteQuestion: async ({dispatch, commit, getters, rootGetters}, questionId) => {
    await RoomQuestion.deleteQuestion(questionId)
  },
  
  setQuestion: async ({dispatch, commit, getters, rootGetters}, {questionId, statusType, value}) => {
    await RoomQuestion.setQuestion({questionId, statusType, value})
  },

  // 질문 공개 여부 변경
  changeQuestionOpenStatus: async ({dispatch, commit, getters, rootGetters}, params) => {
    await RoomQuestion.changeQuestionOpenStatus(params)
  },

  // 댓글 등록
  postComment: async ({dispatch, commit, getters, rootGetters}, params) => {
    await RoomQuestion.postComment(params);
  },

  // 댓글 삭제
  deleteComments: async ({dispatch, commit, getters, rootGetters}, params) => {
    await RoomQuestion.deleteComments(params);
  },

  // 댓글 좋아요
  likeComments: async ({dispatch, commit, getters, rootGetters}, params) => {
    await RoomQuestion.likeComments(params);
  },

  // 댓글 좋아요 취소
  cancelLikeComments: async ({dispatch, commit, getters, rootGetters}, params) => {
    await RoomQuestion.cancelLikeComments(params);
  }
};
